<template>
  <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in"> -->
  <div class="text-xs-left">
    <div>
      <BotLogoManager :bot="selectedBot">
        <template #logo="pageLogo">
          <img
            v-if="showProfile && answers.length > 0 && answers[0].length > 0"
            :src="pageLogo"
            alt
            style="
              margin-left: 10px;
              width: 28px;
              height: 28px;
              border: 1px solid #eee;
              border-radius: 50%;
              float: left;
              margin-right: 5px;
            "
          />
        </template>
      </BotLogoManager>

      <div style="overflow-y: auto">
        <div
          v-for="(message, index) in answers[intent_index]"
          :key="'answer_message_' + index"
          style="margin-bottom: 5px"
        >
          <template v-if="message.type == 'text' || message.type == 'button'">
            <template v-if="message.text == '{viewsummary}'">
              <view-cart-summary-viewer></view-cart-summary-viewer>
            </template>
            <template v-else>
              <template v-if="isShowThreadReplyIgStory">
                <div
                  v-if="
                    data &&
                    data.story_id &&
                    data.story_id !== null &&
                    data.story_url &&
                    data.story_url !== null
                  "
                  class="py-1"
                >
                  <div class="pl-2 pb-1 caption">{{ $t('replied_to_your_story') }}</div>
                  <div style="border-left: 4px solid #ccc" class="pl-2">
                    <img
                      v-if="data.story_url"
                      :src="data.story_url"
                      alt
                      style="width: 150px; height: auto"
                    />
                  </div>
                </div>
              </template>

              <div
                v-if="
                  (message.text != '' && message.type == 'text') ||
                  (message.type == 'button' && (message.buttons.length > 0 || message.text != ''))
                "
                class="message"
                style="
                  width: 100%;
                  word-break: break-word;
                  position: relative;
                  border-radius: 12px;
                  max-width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  margin-bottom: 5px;
                  white-space: initial;
                "
                :style="{ float: align }"
              >
                <div :style="{ color: color, fontSize }">
                  <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                    <span style="line-height: 15.36px; line-height: 22px">
                      <template v-if="message.text != ''">
                        <specialtext :text="clearText(message.text)"></specialtext>
                      </template>
                      <template v-else>-</template>
                    </span>
                  </div>
                </div>
                <div
                  v-if="message.buttons && message.buttons.length > 0"
                  style="
                    width: 100%;
                    border: 1px solid #eee;
                    border-bottom-right-radius: 12px;
                    border-bottom-left-radius: 12px;
                    overflow: hidden;
                  "
                  :style="{ float: align }"
                >
                  <ul class="list-group list-group-flush" style="margin-bottom: 0px">
                    <li
                      v-for="(button, bindex) in message.buttons"
                      :key="bindex"
                      class="list-group-item"
                      style="
                        border: none;
                        border-top: 1px solid #eee;
                        border-radius: 0px;
                        text-align: center;
                        padding: 2px 15px;
                      "
                      :style="{
                        'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                        padding: !showDeep ? '10px 0' : '2px 15px'
                      }"
                    >
                      <template v-if="button">
                        <span style="color: #0084ff">
                          <template v-if="button.type == 'web_url'">
                            <a
                              v-if="isURL(button.url)"
                              :href="updateQueryString(button.url, 'from', 'livechat')"
                              target="_blank"
                              rel="noopener noreferrer"
                              >{{ button.title | truncate(20) }}
                            </a>
                            <div v-else class="primary--text">
                              {{ button.title | truncate(20) }}
                            </div>
                          </template>
                          <template v-else>
                            <span
                              v-clipboard:copy="button.title"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onCopyError"
                              style="cursor: pointer"
                            >
                              {{ button.title | truncate(20) }}
                            </span>
                          </template>
                        </span>
                        <div v-if="showDeep" style="margin: 0; font-size: 10px">
                          <span v-if="button.type == 'web_url'" :title="button.url">{{
                            button.url | truncate(20)
                          }}</span>
                          <span
                            v-else-if="button.type == 'postback'"
                            v-clipboard:copy="button.payload"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onCopyError"
                            style="cursor: pointer"
                            :title="button.payload"
                            >{{ button.payload | truncate(20) }}</span
                          >
                          <span
                            v-else-if="button.type == 'phone_number'"
                            :class="selectedBot.theme == 'toa' ? 'toaphonenumber' : ''"
                            :title="button.payload"
                            >{{ button.payload | truncate(20) }}</span
                          >
                          <span v-else>&nbsp;</span>
                        </div>
                      </template>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="message.type == 'image'">
            <template v-if="message && message.image_url">
              <FacebookContent
                v-if="
                  message.image_url &&
                  messageId &&
                  data &&
                  !(data.userid.startsWith('U') || data.userid.startsWith('LU')) &&
                  !message.image_url.match(';;')
                "
                :value="messageId"
                :type="message.type"
                :image_url="message.image_url"
              >
                <template #default="{ url }">
                  <div v-if="isMultipleUrl(url)">
                    <div v-for="(item, index) in url" :key="index">
                      <image-type
                        :value="item"
                        alt
                        style="border: 1px solid transparent; width: 181px; border-radius: 15px"
                      />
                    </div>
                  </div>
                  <div v-else>
                    <image-type
                      :value="url"
                      alt
                      style="border: 1px solid transparent; width: 181px; border-radius: 15px"
                    />
                  </div>
                </template>
              </FacebookContent>
              <!-- <template v-for="(image, k) in $options.filters.splitimg(message.image_url)"> -->
              <template v-for="(image, k) in $options.filters.splitimg(message.image_url)" v-else>
                <image-type
                  :key="`image_${k}`"
                  :value="image"
                  :width="
                    message.image_url &&
                    message.image_url != null &&
                    $options.filters.splitimg(message.image_url).length > 1
                      ? '100px'
                      : '181px'
                  "
                  :align="align"
                ></image-type>
              </template>
            </template>
          </template>
          <template v-else-if="message.type == 'multiple_image'">
            <div
              :style="{
                display: 'grid',
                gridTemplateColumns: 'fit-content(50%) fit-content(50%)',
                gap: '0.5rem',
                alignItems: 'center',
                border: '1px solid #e8e5e5',
                borderRadius: '1rem',
                padding: '0.5rem',
                maxWidth: 'fit-content',
                overflow: 'auto'
              }"
            >
              <image-type
                v-for="(url, urlIndex) in message.image_urls"
                :key="urlIndex"
                :value="url"
                alt
                style="width: 160px; border-radius: 1rem"
              />
            </div>
          </template>
          <template
            v-else-if="
              message.type == 'video' &&
              $route.name == 'allinonechat' &&
              message.video_url &&
              (typeof message.video_url == 'object' || message.video_url.startsWith('{'))
            "
          >
            <div
              class="message"
              style="
                position: relative;
                border-radius: 12px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                margin-bottom: 5px;
                white-space: initial;
              "
              :style="{ float: align }"
            >
              <div style="font-size: 12px" :style="{ color: color }">
                <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                  <span style="line-height: 15.36px; line-height: 22px">
                    <LineContentVideo :value="message.video_url" :pageid="currentPageId">
                      <template #default="{ url }">
                        <video width="100%" height="80%" controls>
                          <source type="video/mp4" :src="url" />
                        </video>
                      </template>
                    </LineContentVideo>
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template
            v-else-if="
              message.type == 'video' && $route.name == 'allinonechat' && message.video_url
            "
          >
            <div
              class="message"
              style="
                position: relative;
                border-radius: 12px;
                max-width: 250px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                margin-bottom: 5px;
                white-space: initial;
              "
              :style="{ float: align }"
            >
              <div :style="{ color: color, fontSize }">
                <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                  <span style="line-height: 15.36px; line-height: 22px">
                    <FacebookContent
                      v-if="
                        message.video_url &&
                        messageId &&
                        data &&
                        !(data.userid.startsWith('U') || data.userid.startsWith('LU'))
                      "
                      :value="messageId"
                      :video_url="message.video_url"
                    >
                      <template #default="{ url, mime_type }">
                        <video width="100%" height="80%" controls>
                          <source :type="mime_type" :src="url" />
                        </video>
                      </template>
                    </FacebookContent>
                    <template v-else-if="message.video_url">
                      <div v-if="message.video_url">
                        <video width="100%" height="200px" controls>
                          <source :src="message.video_url" type="video/mp4" />
                        </video>
                      </div>
                    </template>
                    <template v-else-if="message.source">
                      <div v-if="message.source">
                        <video width="100%" height="200px" controls>
                          <source :src="message.source" type="video/mp4" />
                        </video>
                      </div>
                    </template>

                    <div v-else>-</div>
                  </span>
                </div>
              </div>
            </div>
          </template>

          <template v-else-if="message.type == 'audio'">
            <div
              class="message"
              style="
                position: relative;
                border-radius: 12px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                margin-bottom: 5px;
                white-space: initial;
              "
              :style="{ float: align }"
            >
              <template v-if="message.text != ''">
                <template v-if="channel == 'line'">
                  <LineContentVideo
                    :value="message.audio_url"
                    :pageid="currentPageId"
                    :video_url="message.audio_url"
                  >
                    <template #default="{ url }">
                      <audio controls>
                        <source :src="url" type="audio/ogg" />
                        <source :src="url" type="audio/mpeg" />
                      </audio>
                    </template>
                  </LineContentVideo>
                </template>
                <template v-else>
                  <audio controls>
                    <source :src="message.audio_url" type="audio/ogg" />
                    <source :src="message.audio_url" type="audio/mpeg" />
                  </audio>
                </template>
              </template>
              <template v-else>-</template>
            </div>
          </template>
          <template v-else-if="message.type == 'payment'">
            <div
              :style="{ float: align }"
              style="
                padding: 1em;
                text-align: left;
                position: relative;
                border-radius: 12px;
                width: 281px;
                min-height: 100px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                background-color: #eeeeee;
              "
            >
              <v-layout style="margin-bottom: 0px" row>
                <vue-simple-svg
                  :filepath="'/static/img/assets/get_started/payment.svg'"
                  width="40px"
                  height="40px"
                  class="img"
                  style="
                    border-right: 2px solid #c5c5c5;
                    padding-right: 10px;
                    padding-top: 1em;
                    padding-bottom: 1em;
                    vertical-align: middle;
                  "
                />
                <v-flex style="padding-left: 1em">
                  <div style="margin-bottom: 10px">
                    <strong>{{ $t('Detail') }}:</strong>
                    <br />
                    {{ message.data.detail }}
                  </div>
                  <div style="margin-bottom: 10px">
                    <strong>{{ $t('Amount') }}:</strong>
                    <br />
                    {{ message.data.amount }}
                  </div>
                  <div style="margin-bottom: 10px">
                    <strong>{{ $t('Delivery Method') }}:</strong>
                    <br />
                    {{ message.data.delivery.name }}
                  </div>
                  <div style="margin-bottom: 10px">
                    <strong>{{ $t('Response Message') }}:</strong>
                    <br />
                    {{ message.data.response }}
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <template
            v-else-if="['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type)"
          >
            <span>
              <view-cart-summary-viewer2 :items="message.data"></view-cart-summary-viewer2>
            </span>
            <span></span>
          </template>

          <template v-else-if="message.type == 'generic'">
            <generic-viewer
              v-model="message.data"
              :size="size"
              :align="align"
              :ratio="message.ratio"
            ></generic-viewer>
          </template>
          <template v-else-if="message.type == 'meta_pay'">
            <div
              style="
                padding: 1em;
                float: left;
                position: relative;
                border-radius: 12px;
                width: 240px;
                min-height: 100px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                background-color: #eeeeee;
                margin-bottom: 5px;
              "
            >
              <v-layout style="margin-bottom: 0px; word-break: break-all" row>
                <vue-simple-svg
                  :filepath="'/static/img/assets/get_started/payment.svg'"
                  width="35px"
                  height="35px"
                  class="img"
                  style="
                    padding-right: 10px;
                    padding-top: 1em;
                    padding-bottom: 1em;
                    vertical-align: middle;
                  "
                />
                <h4
                  style="
                    color: #000;
                    align-self: center;
                    font-size: 16px;
                    margin-left: 11px;
                    white-space: normal;
                    line-height: normal;
                  "
                >
                  ฿{{ message.amount }} ส่งคำขอให้ชำระเงินแล้ว
                </h4>
              </v-layout>
              <h4
                class="text-xs-center"
                style="background: #fff; padding: 12px; border-radius: 14px; color: #000"
              >
                ชำระเงิน
              </h4>
            </div>
          </template>
          <template v-else-if="message.type == 'ntn_template'">
            <ntn-viewer
              :key="'generic_'"
              :ratio="message.ratio"
              :ntn_message="message.data"
              :size="size"
            ></ntn-viewer>
          </template>
          <template v-else-if="message.type == 'welcome_message'">
            <WelcomeMessageViewer
              v-model="welcomemessage.messages"
              :size="size"
            ></WelcomeMessageViewer>
          </template>

          <template v-else-if="message.type == 'video'">
            <div
              class="message"
              style="
                min-height: 150px;
                border: 1px solid #eee;
                position: relative;
                border-radius: 12px;
                width: 181px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
              "
              :style="{ float: align }"
            >
              <template v-if="$route.name == 'allinonechat'">
                <div v-if="message.source">
                  <video width="100%" controls>
                    <source :src="message.source" type="video/mp4" />
                  </video>
                </div>
              </template>
              <template v-else>
                <template v-if="message.picture">
                  <v-img :src="message.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                </template>
                <template v-else>
                  <v-responsive :aspect-ratio="16 / 9">
                    <div style="background: #eee; height: 100%"></div>
                  </v-responsive>
                </template>

                <v-layout
                  fill-height
                  absolute
                  class="text-xs-center"
                  style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                >
                  <div
                    style="margin: auto; width: 100%"
                    :title="message.source"
                    :alt="message.source"
                  >
                    <v-btn fab small depressed color="white">
                      <v-icon large>play_circle_filled</v-icon>
                    </v-btn>
                  </div>
                </v-layout>
              </template>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="message.type == 'responsepost'">
            <template v-if="message.replyinbox">
              <em class="fas fa-check-circle primary-color" />
              {{ $t('Reply to inbox') }}
              <div
                v-for="(inbox, iindex) in message.responseinbox"
                :key="'response_inbox_' + iindex"
              >
                <template v-if="inbox.type == 'text' || inbox.type == 'button'">
                  <div
                    v-if="
                      (inbox.text != '' && inbox.type == 'text') ||
                      (inbox.type == 'button' && (inbox.buttons.length > 0 || inbox.text != ''))
                    "
                    class="message"
                    style="
                      position: relative;
                      border-radius: 12px;
                      max-width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                      white-space: initial;
                    "
                    :style="{ float: align }"
                  >
                    <div :style="{ color: color, fontSize }">
                      <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                        <span style="line-height: 15.36px; line-height: 22px">
                          <template v-if="inbox.text != ''">
                            <specialtext :text="inbox.text"></specialtext>
                          </template>
                          <template v-else>-</template>
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="inbox.buttons && inbox.buttons.length > 0"
                      style="
                        width: 100%;
                        border: 1px solid #eee;
                        border-bottom-right-radius: 12px;
                        border-bottom-left-radius: 12px;
                        overflow: hidden;
                      "
                      :style="{ float: align }"
                    >
                      <ul class="list-group list-group-flush" style="margin-bottom: 0px">
                        <li
                          v-for="(button, bindex) in inbox.buttons"
                          :key="bindex"
                          class="list-group-item"
                          style="
                            border: none;
                            border-top: 1px solid #eee;
                            border-radius: 0px;
                            text-align: center;
                            padding: 2px 15px;
                          "
                          :style="{
                            'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                            padding: !showDeep ? '10px 0' : '2px 15px'
                          }"
                        >
                          <span style="color: #0084ff">
                            <a
                              v-if="button.type == 'web_url'"
                              :href="updateQueryString(button.url, 'from', 'livechat')"
                              target="_blank"
                              rel="noopener noreferrer"
                              >{{ button.title | truncate(20) }}
                            </a>
                            <template v-else>
                              {{ button.title | truncate(20) }}
                            </template></span
                          >
                          <div v-if="showDeep" style="margin: 0; font-size: 10px">
                            <span v-if="button.type == 'web_url'" :title="button.url">{{
                              button.url | truncate(20)
                            }}</span>
                            <span v-else-if="button.type == 'postback'" :title="button.payload">{{
                              button.payload | truncate(20)
                            }}</span>
                            <span
                              v-else-if="button.type == 'phone_number'"
                              :title="button.payload"
                              >{{ button.payload | truncate(20) }}</span
                            >
                            <span v-else>&nbsp;</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </template>
                <template v-else-if="inbox.type == 'image'">
                  <div
                    v-if="inbox.image_url"
                    class="message"
                    style="
                      position: relative;
                      border-radius: 12px;
                      width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                    "
                    :style="{ float: align }"
                  >
                    <div style="font-size: 15px; color: black; line-height: 0">
                      <img :src="inbox.image_url" alt style="width: 100%" />
                    </div>
                  </div>
                </template>
                <template v-else-if="inbox.type == 'generic'">
                  <generic-viewer
                    v-model="inbox.data"
                    :size="size"
                    :ratio="inbox.ratio"
                  ></generic-viewer>
                </template>
                <template v-else-if="inbox.type == 'ntn_template'">
                  <ntn-viewer :ratio="inbox.ratio" :ntn_message="inbox" :size="size"></ntn-viewer>
                </template>
                <template v-else-if="inbox.type == 'welcome_message'">
                  <WelcomeMessageViewer
                    v-model="welcomeinbox.messages"
                    :size="size"
                  ></WelcomeMessageViewer>
                </template>
                <template v-else-if="inbox.type == 'video'">
                  <div
                    class="message"
                    style="
                      min-height: 150px;
                      border: 1px solid #eee;
                      position: relative;
                      border-radius: 12px;
                      width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                    "
                    :style="{ float: align }"
                  >
                    <template v-if="inbox.picture">
                      <v-img :src="inbox.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                    </template>
                    <template v-else>
                      <v-responsive :aspect-ratio="16 / 9">
                        <div style="background: #eee; height: 100%"></div>
                      </v-responsive>
                    </template>

                    <v-layout
                      fill-height
                      absolute
                      class="text-xs-center"
                      style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                    >
                      <div
                        style="margin: auto; width: 100%"
                        :title="inbox.source"
                        :alt="inbox.source"
                      >
                        <v-btn fab small depressed color="white">
                          <v-icon large>play_circle_filled</v-icon>
                        </v-btn>
                      </div>
                    </v-layout>
                  </div>
                  <div class="clearfix"></div>
                </template>
                <template v-else-if="inbox.type == 'flex'">
                  <div class="line-flex text-xs-left pa-2" :style="{ float: align }">
                    <line-flex-preview :value="message" :index="index"></line-flex-preview>
                  </div>
                  <div class="clearfix"></div>
                </template>
                <template
                  v-else-if="
                    ['removeandaddtocart', 'addtocart', 'removetocart'].includes(inbox.type)
                  "
                >
                  <span>
                    <view-cart-summary-viewer2 :items="inbox.data"></view-cart-summary-viewer2>
                  </span>
                  <span></span>
                </template>
                <template v-else-if="['product_catalog'].includes(inbox.type)">
                  <template v-if="inbox.product_catalog_message.type === 'add_product_by_bot'">
                    <generic-viewer
                      v-model="inbox.product_catalog_message.data.data"
                    ></generic-viewer>
                  </template>
                  <template v-if="inbox.product_catalog_message.type === 'show_products_by_bot'">
                    <div
                      class="text-xs-center pa-2 mb-2"
                      style="border: 1px solid #eee; float: left; border-radius: 10px"
                    >
                      <div class="py-2">
                        <div class="primary--text">Show Products by Bot</div>
                        <div class="grey--text caption">
                          {{ inbox.product_catalog_message.data }}
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </template>
                  <template
                    v-else-if="
                      inbox.product_catalog_message.type === 'management_product_to_cart_comment'
                    "
                  >
                    <ViewProductCatalogCartSummaryViewer
                      v-model="inbox.product_catalog_message.data"
                    ></ViewProductCatalogCartSummaryViewer>
                  </template>
                </template>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-if="message.replycomment && !showProfile">
              <em class="fas fa-check-circle primary-color" />
              {{ $t('Reply to comment') }}
              <div
                v-for="(comment, cindex) in message.responsecomment"
                :key="'response_comment_' + cindex"
              >
                <div
                  v-if="comment.text != '' && comment.type == 'text'"
                  class="message"
                  style="
                    position: relative;
                    border-radius: 12px;
                    max-width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    margin-bottom: 5px;
                  "
                  :style="{ float: align }"
                >
                  <div :style="{ color: color, fontSize }">
                    <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                      <span style="line-height: 15.36px; line-height: 22px">
                        <template v-if="comment.text != ''">
                          <specialtext :text="comment.text"></specialtext>
                        </template>
                        <template v-else>-</template>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div
                  v-if="comment.image_url"
                  class="message"
                  style="
                    position: relative;
                    border-radius: 12px;
                    width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    margin-bottom: 5px;
                  "
                  :style="{ float: align }"
                >
                  <div style="font-size: 15px; color: black">
                    <img :src="comment.image_url" alt style="width: 100%" />
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-if="message.hidecomment && !showProfile">
              <em class="fas fa-check-circle primary-color" />
              {{ $t('Hide comment') }}
            </template>
          </template>
          <template v-else-if="message.type == 'flex'">
            <div class="line-flex text-xs-left pa-2" :style="{ float: align }">
              <line-flex-preview :value="message" :index="index"></line-flex-preview>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="message.type == 'imagemap' || message.type == 'basicimagemap'">
            <div
              class="text-xs-center pa-2"
              style="border: 1px solid #eee; border-radius: 10px"
              :style="{ float: align }"
            >
              <img :src="message.baseUrl" style="width: 100%; max-width: 255px" />
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="message.type == 'sticker'">
            <div
              class="text-xs-center pa-2 mb-1"
              style="border: 1px solid #eee; border-radius: 10px; width: 100%; max-width: 180px"
              :style="{ float: align }"
            >
              <v-img
                aspect-ratio="1"
                :src="`/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`"
                :lazy-src="`/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`"
                style="width: 100%"
              >
                <template #placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </div>
          </template>
          <template v-else-if="message.type == 'file'">
            <div
              class="message mb-2"
              style="
                word-break: break-word;
                position: relative;
                border-radius: 12px;
                max-width: 159px;
                overflow-wrap: break-word;
                min-height: 9px;
                min-width: 3px;
                line-height: 15.36px;
                overflow: hidden;
                white-space: initial;
                float: left;
              "
            >
              <div style="font-size: 15px; color: black">
                <div style="padding: 5px 8px 6px; background-color: rgb(241, 240, 240)">
                  <a
                    style="color: black; font-weight: bold"
                    @click="
                      channel && channel == 'webchat'
                        ? handleWebchatFileMessage(message.data)
                        : linemessagecontenttypefile(message.data)
                    "
                  >
                    <div v-if="fileloading" class="pa-2">
                      <v-progress-circular
                        indeterminate
                        color="grey"
                        size="25"
                      ></v-progress-circular>
                    </div>
                    <div v-else>
                      <v-icon style="font-size: medium">insert_drive_file</v-icon>

                      {{ getFileName(message.data) }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="message.type == 'share'">
            <div
              v-if="message.image_url"
              class="message"
              style="
                position: relative;
                border-radius: 12px;
                width: 181px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                margin-bottom: 5px;
              "
              :style="{ float: align }"
            >
              <div
                :style="{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  padding: '15px 10px',
                  backgroundColor: '#e9e9e9'
                }"
              >
                SHARE POST
              </div>
              <div style="font-size: 15px; color: black; line-height: 0">
                <img :src="message.image_url" alt style="width: 100%" />
              </div>
            </div>
          </template>
          <template v-else-if="message.type == 'talk_to_human'">
            <div v-if="showTalkToHuman">{{ JSON.stringify(message.payload, null, 2) }}</div>
            <div style="display: flex; gap: 4px; align-items: center">
              <div
                class="message"
                style="
                  width: 100%;
                  word-break: break-word;
                  position: relative;
                  border-radius: 12px;
                  max-width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  margin-bottom: 5px;
                  white-space: initial;
                "
                :style="{ float: align }"
              >
                <div :style="{ color: color, fontSize }">
                  <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                    <span style="line-height: 15.36px; line-height: 22px">
                      <template v-if="message.text != ''">
                        <specialtext :text="clearText(message.text)"></specialtext>
                      </template>
                      <template v-else>-</template>
                    </span>
                  </div>
                </div>
              </div>
              <v-icon small @click="showTalkToHuman = !showTalkToHuman">info</v-icon>
            </div>
          </template>
          <template v-else-if="message.type == 'tree_view'">
            <TreeViewViewer v-model="message.tree_view" />
          </template>

          <template v-if="message.type.includes('show_products_by_bot')">
            <div
              class="text-xs-center pa-2 mb-2"
              style="border: 1px solid #eee; float: left; border-radius: 10px"
            >
              <div class="py-2">
                <div class="primary--text">Show Products by Bot</div>
                <div class="grey--text caption">{{ message.data }}</div>
              </div>
              <div class="clearfix"></div>
            </div>
          </template>
          <template v-if="message.type.includes('management_product_to_cart_comment')">
            <ViewProductCatalogCartSummaryViewer
              v-model="message.data"
            ></ViewProductCatalogCartSummaryViewer>
            <!-- <div
              class="text-xs-center pa-2 mb-2"
              style="border: 1px solid #eee; float: left; border-radius: 10px"
            >
              <div class="py-2">
                <div class="primary--text">Show Products by Bot</div>
                <div class="grey--text caption">{{ message.data }}</div>
              </div>
              <div class="clearfix"></div>
            </div> -->
          </template>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <v-layout
      v-if="showQuickReply && quickReply && quickReply.length && quickReply[0]"
      class="ml-4"
      row
      wrap
    >
      <div
        v-for="(quick_reply, index) in quickReply"
        :key="`quick-${index}`"
        style="width: max-content; border-radius: 12px"
        class="bg-chat mx-2 px-4 py-2 mt-2 border"
      >
        {{ quick_reply }}
      </div>
    </v-layout>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Copied') }}!</v-snackbar
    >
  </div>
  <!-- </transition> -->
</template>

<script>
import GenericViewer from '@/components/elements/GenericViewer'
import TreeViewViewer from '@/components/elements/TreeViewViewer'
import NtnViewer from '@/components/elements/NtnViewer'
import specialtext from '@/components/elements/specialtext'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import config from '@/config'
import { mapGetters } from 'vuex'
import FacebookContent from './FacebookContent.vue'
import ImageType from './ImageType'
import LineContentVideo from './LineContentVideo.vue'
import LineFlexPreview from './LineFlexPreview'
import WelcomeMessageViewer from './WelcomeMessageViewer.vue'
import BotLogoManager from '@/components/elements/BotLogoManager.vue'
import ViewProductCatalogCartSummaryViewer from '@/components/elements/ViewProductCatalogCartSummaryViewer'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'MessageViewer',
  filters: {
    splitimg: function (value) {
      return value.split(';;')
    }
  },
  components: {
    NtnViewer,
    specialtext,
    GenericViewer,
    ViewCartSummaryViewer,
    ViewCartSummaryViewer2,
    ImageType,
    LineFlexPreview,
    WelcomeMessageViewer,
    LineContentVideo,
    FacebookContent,
    BotLogoManager,
    TreeViewViewer,
    ViewProductCatalogCartSummaryViewer
  },
  props: {
    value: { type: [Object, String, Array], default: null },
    background: {
      type: String,
      default: '#F1F0F0'
    },
    showQuickReply: {
      type: Boolean,
      default: false
    },
    quickReply: {
      type: Array,
      default: null
    },
    color: {
      type: String,
      default: 'black'
    },
    showDeep: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'big'
    },
    fontSize: {
      type: String,
      default: '12px'
    },
    showProfile: {
      default: false,
      type: Boolean
    },
    align: {
      type: String,
      default: 'left'
    },
    channel: {
      type: String,
      default: ''
    },
    messageId: {
      default: null
    },
    data: {
      default: null
    }
  },
  data: function () {
    return {
      fileloading: false,
      group: this.value,
      intent_index: 0,
      showCopy: false,
      randomAnswerInterval: null,
      showTalkToHuman: false,
      answers: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage',
      livechat: 'livechat'
    }),
    isShowThreadReplyIgStory() {
      if (['cityfresh'].includes(this.selectedBot.theme)) {
        return true
      } else {
        return false
      }
    },
    currentPageId() {
      if (this.livechat) return this.livechat.pageid
      return this.selectedBot.pageid
    }
  },

  watch: {
    group: {
      handler() {
        this.handleTransformAnswer()
      },
      deep: true
    }
  },
  mounted: function () {
    const vm = this
    const tempValue = cloneDeep(vm.value)
    vm.group = tempValue

    if (vm.answers.length > 1) {
      vm.randomAnswerInterval = setInterval(() => {
        if (vm.intent_index == vm.answers.length - 1) {
          vm.intent_index = 0
        } else {
          vm.intent_index++
        }
      }, 3000)
    }
  },

  beforeDestroy() {
    if (this.randomAnswerInterval) {
      clearInterval(this.randomAnswerInterval)
    }
  },

  methods: {
    handleTransformAnswer() {
      try {
        const vm = this
        const tempGroup = cloneDeep(vm.group)

        if (tempGroup == null) {
          return []
        }

        let messagelist = []
        for (let index = 0; index < tempGroup.length; index++) {
          const group = tempGroup[index]

          var newGroup = []
          for (let mindex = 0; mindex < group.length; mindex++) {
            const message = group[mindex]

            try {
              if (message.type === 'button' && message.buttons) {
                message.buttons = message.buttons.filter(Boolean)
              }
            } catch (error) {
              console.error(error)
            }
            if (
              (message.type === 'text' && message.text !== '') ||
              (message.type === 'button' &&
                message.buttons &&
                (message.buttons.length > 0 || message.text !== '')) ||
              (message.type === 'image' &&
                message.image_url !== '' &&
                message.image_url !== null) ||
              (message.type === 'multiple_image' &&
                message.image_urls &&
                message.image_urls.length > 0) ||
              (message.type === 'share' &&
                message.image_url !== '' &&
                message.image_url !== null) ||
              message.type === 'welcome_message' ||
              (message.type === 'flex' && message.contents !== '') ||
              (message.type === 'payment' && message.detail !== '') ||
              (message.type === 'meta_pay' && message.detail !== '') ||
              (['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type) &&
                message.detail !== '')
            ) {
              newGroup.push(message)
            } else if (message.type === 'generic') {
              var generics = []
              for (let gindex = 0; gindex < message.data.length; gindex++) {
                const g = message.data[gindex]
                try {
                  if (g.buttons) g.buttons = g.buttons.filter(Boolean)
                } catch (error) {
                  console.error(error)
                }
                if (
                  g.title !== '' ||
                  g.subtitle !== '' ||
                  g.buttons.length > 0 ||
                  (g.image_url !== '' && g.image_url != null) ||
                  (typeof g.productid != 'undefined' && g.productid != null)
                ) {
                  generics.push(g)
                }
              }

              if (generics.length > 0) {
                newGroup.push({
                  type: 'generic',
                  data: generics,
                  ratio: message.ratio == 'horizontal' ? 'horizontal' : 'square'
                })
              }
            } else if (message.type === 'ntn_template') {
              newGroup.push({
                type: 'ntn_template',
                data: message,
                ratio: 'horizontal'
              })
            } else if (message.type === 'responsepost') {
              if (vm.showProfile) {
                if (
                  message.replyinbox === true &&
                  message.responseinbox[0].text !== '' &&
                  message.responseinbox[0].text !== null
                ) {
                  newGroup.push(message)
                }
              } else {
                if (
                  (message.replyinbox === true &&
                    message.responseinbox[0].text !== '' &&
                    message.responseinbox[0].text !== null) ||
                  (message.replycomment === true &&
                    message.responsecomment[0].text !== '' &&
                    message.responsecomment[0].text !== null) ||
                  message.hidecomment === true
                ) {
                  newGroup.push(message)
                }
              }
            } else if (
              [
                'video',
                'audio',
                'imagemap',
                'basicimagemap',
                'sticker',
                'file',
                'tree_view'
              ].includes(message.type)
            ) {
              newGroup.push(message)
            } else if (['talk_to_human'].includes(message.type)) {
              newGroup.push(message)
            } else if (['product_catalog'].includes(message.type)) {
              if (
                message.product_catalog_message &&
                message.product_catalog_message.type === 'add_product_by_bot'
              ) {
                newGroup.push(message.product_catalog_message.data)
              } else {
                newGroup.push(message.product_catalog_message)
              }
            }
          }

          if (newGroup.length > 0) {
            messagelist.push(newGroup)
          }
        }

        if (messagelist.length === 0) {
          messagelist = [[]]
        }

        // vm.group = messagelist
        vm.answers = messagelist
      } catch (error) {
        console.error(error)
      }
    },
    isMultipleUrl: function (url) {
      try {
        if (Array.isArray(url) && url.length > 0) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.error(error)
        return false
      }
    },
    getFileName(message) {
      try {
        var data = JSON.parse(message)
        return data.fileName
      } catch (error) {
        return 'File'
      }
    },
    clearText(text) {
      if (text) {
        // eslint-disable-next-line no-useless-escape
        return text.replace(/\{savesession\(.*?\,.*?\)\}/gim, '')
      }
      return ''
    },
    handleWebchatFileMessage(data) {
      const url = data
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.click()
    },
    linemessagecontenttypefile(messageid) {
      if (!this.fileloading) {
        var data = messageid
        try {
          data = JSON.parse(messageid)
        } catch (error) {
          data = messageid
        }
        var urldownload = `${config.serverUrl}linemessagecontenttypefile?pageid=${this.currentPageId}&messageid=${data.id}`
        this.fileloading = true
        fetch(urldownload)
          .then((resp) => resp.blob())
          .then((blob) => {
            this.fileloading = false
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            // the filename you want
            a.download = this.getFileName(messageid)
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
          })
          .catch(() => alert("Can't download this file"))
      }
    },
    goLinkBtn(link) {
      window.location.assign(link)
    },
    updateQueryString(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      var separator = uri.indexOf('?') != -1 ? '&' : '?'
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        return uri + separator + key + '=' + value
      }
    },
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError: function () {}
  }
}
</script>

<style scoped>
.message {
  word-break: break-word;
}
.toaphonenumber {
  font-size: 12px;
  color: red;
  line-height: 23px;
  /* margin-top: 15px; */
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/MessageViewer.vue